@for (i of [1, 2]; track $index) {
  <ng-container>
    <div class="sync-grid">
      @for (i of [1, 2, 3, 4]; track $index) {
        <ng-container>
          <ds-skeleton type="card" [showAnimation]="true"> </ds-skeleton>
        </ng-container>
      }
    </div>
  </ng-container>
}
